import { Text, Title } from './../Typography';
import { CorpOurPeopleItem } from '../../generated/graphql';
import { getPictureSources } from '../../lib/utils/helpers';
import { Picture } from 'react-responsive-picture';
import { IconWrapper, ImageContainer } from './styles';
import { getCopy } from '../../lib/utils/getCopy';
import { DictionaryItem } from '../../types/Dictionary';
import { ChefHat } from '../Icons/icons';
import clsx from 'clsx';

export function CorpOurPeople(data: { corpOurPeopleItems: Array<CorpOurPeopleItem>, copy: DictionaryItem[] }) {


  return (
    <div className="px-small 2xl:px-medium 3xl:px-xlarge">
        {data?.corpOurPeopleItems.map((item, index) => {
          const isOdd = index % 2 !== 0;
          const Description = ({hideOnLarge}:{hideOnLarge?: boolean}) => {
            return <div className={hideOnLarge ? "block md:hidden" : "hidden md:block"}>
              <Text tag='p' type='lg' className='mb-2 md:mb-5'>
                {item.text}
              </Text>
              <div className="flex items-start md:items-center">
                <IconWrapper>
                  <ChefHat className='' />
                </IconWrapper>
                <div className="flex flex-col md:flex-row items-start md:items-center flex-wrap ">
                  <Text tag='p' type='lead' className='shrink-0 md:mr-1'>
                    {getCopy('favorite_product', data?.copy)}:
                  </Text>
                  <Text tag='p' type='md'>
                    {item.favoriteProduct}
                  </Text>
                </div>
              </div>
            </div>
          }

          return <div key={`our-people-item-${item.id}`}
                      className={clsx('text-corporate-blue mb-[100px] md:last:mb-[150px] flex flex-nowrap flex-col md:flex-row', isOdd && 'md:flex-row-reverse')}>
            <div className={clsx("our-people-item-text basis:2/3 lg:basis-2/4", isOdd ? "md:ml-5" : "md:mr-5")} >
              <Title tag='p' type='md' className='mb-2 md:mb-2.5 scroll-mt-14' id={item.name.split(' ').join('-').toLowerCase()}>
                {item.name}
              </Title>
              <Title tag='p' type='xxs' className='mb-3 md:mb-0'>
                {item.description}
              </Title>
              <Description />
            </div>
              {!!item.image?.asset[0] && (
                <ImageContainer className={clsx('mb-2 md:mb-4 basis:1/3 lg:basis-2/4', isOdd ? "md:mr-5" : "md:ml-5")}>
                  <Picture  sources={getPictureSources(item.image?.asset[0])} alt="" />
                </ImageContainer>
              )}

            <Description hideOnLarge/>

          </div>
        })}
    </div >
  );
}
